'use strict';

/**
 easing 参考
 jquery: http://semooh.jp/jquery/cont/doc/easing/
 tweenmax: https://greensock.com/ease-visualizer
 tween: https://github.com/chenglou/tween-functions
*/

const Config = {
	breakPoint: {
		tb: 1023,
		sp: 849
	},
	duration: 400,
	ease: {
		// jquery: 'linear',
		// tweenmax: Power0.easeNone,
		tween: 'linear'
	}
}

export default Config;
